var map = {
	"./de.json": 11272,
	"./de/de.admin.json": 83499,
	"./de/de.changelog.json": 17066,
	"./de/de.rules.json": 91835,
	"./de/de.wiki.json": 70784,
	"./en.json": 15188,
	"./en/en.admin.json": 56719,
	"./en/en.changelog.json": 10614,
	"./en/en.rules.json": 82623,
	"./en/en.wiki.json": 89580,
	"./fr.json": 52303,
	"./fr/fr.admin.json": 7069,
	"./fr/fr.changelog.json": 30900,
	"./fr/fr.rules.json": 77209,
	"./fr/fr.wiki.json": 38002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9253;